import _get from 'lodash/get';
import {api} from '../helpers/api';
import utils from '../helpers/utils';

export const ALERT_SUMMARY_REQUEST = 'ALERT_SUMMARY_REQUEST';
export const ALERT_SUMMARY_SUCCESS = 'ALERT_SUMMARY_SUCCESS';
export const ALERT_SUMMARY_FAILURE = 'ALERT_SUMMARY_FAILURE';

function alertSummaryRequest() {
  return {
    type: ALERT_SUMMARY_REQUEST,
  };
}

function alertSummarySuccess(payload: $TSFixMe) {
  const isError = _get(payload, 'errorCode');

  if (isError) {
    return {
      type: ALERT_SUMMARY_FAILURE,
      error: 'Error',
    };
  }

  return {
    type: ALERT_SUMMARY_SUCCESS,
    alertSummary: payload,
  };
}

function alertSummaryFailure(error: $TSFixMe) {
  return {
    type: ALERT_SUMMARY_FAILURE,
    error,
  };
}

export function alertSummary(accountId: string) {
  const url = utils.getAlertSummaryPath();

  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      account_id: accountId,
    },
    credentials: 'include',
  };

  return api(url, config, alertSummaryRequest(), alertSummarySuccess, alertSummaryFailure);
}
